<template>
  <v-app id="folder_list">
    <template>
      <v-expansion-panels focusable @change="onPanelChange">
        <v-expansion-panel>
          <v-expansion-panel-header color="grey darken-3" v-if="!show_folder"
            >Favorites</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-card>
              <v-card-text class="grey darken-2">
                <files
                  :files_update="files_update"
                  :folder_name="'Favorite'"
                  :lst_files="lst_fav_files"
                  @fav_files_update="get_favs"
                ></files>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog2 = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <v-container id="list_container" class="pa-0">
      <v-row class="mt-1 ml-2">
        <v-col
          cols="12"
          class="folder-list d-flex justify-start pa-0 ml-1 pb-1"
          style="margin-top: 9px; margin-bottom: 18px"
        >
          <h3 class="ml-1" v-if="show_folder == false">SECTIONS</h3>
        </v-col>
      </v-row>
      <folder
        :folder_name="cur_folderName"
        @backtofolders="backtofolders"
        v-if="show_folder"
      ></folder>
      <v-row no-gutters v-if="show_folder == false">
        <v-col cols="12" md="12" class="">
          <!-- Expansion Panels -->

          <v-container class="list-container pa-0">
            <v-row>
              <v-col cols="12" class="px-3 mt-1">
                <v-list class="list-fname">
                  <v-list-item
                    @click="show_folder_now(item_fname.folder_name)"
                    class="single-name d-flex flex-row justify-space-between"
                    v-for="(item_fname, index) in items_foldername"
                    :key="index"
                  >
                    <!-- <v-btn @click="show_folder_now(item_fname.folder_name)">
                      <v-icon class="justify-self-center">$folder</v-icon>
                    </v-btn> -->
                    <!-- <router-view /> -->

                    <v-list-item-content>
                      <a
                        style="
                          text-decoration: none;
                          font-size: 20px;
                          font-weight: 600;
                        "
                        href="javascript:void(0)"
                        @click="show_folder_now(item_fname.folder_name)"
                        >{{ item_fname.folder_name }}
                        <span class="ml-2 grey--text darken-1 text-subtitle-2"
                          >({{ item_fname.filecnt }})
                        </span>
                      </a>
                      <!-- <router-link
                        class="name-link ml-3"
                        :to="{ name: 'folder' }"
                        >{{ item_fname.folder_name }}</router-link
                      > -->
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style lang="scss" scoped>
/* 0 media q */
a {
  color: #cae2fd !important;
}
@media (min-width: 0px) {
  a {
    color: #cae2fd !important;
  }
  #folder_list {
    width: 100%;
    margin: 0 auto;
  }

  #folder_list:deep.theme--light.v-application {
    background: none;
  }

  #folder_list:deep .v-application--wrap {
    /* min-height: 100vh !important; */
    min-height: auto;
  }

  #list_container {
    width: 100%;
  }

  .name-link {
    color: #90caf9;
    text-decoration: underline;
  }

  .list-fname:deep .v-icon__svg {
    fill: darkorange !important;
  }

  /* roster logs names */

  .roster-toolbar {
    height: 30px !important;
  }

  .single-name {
    border-bottom: 2px solid #0000001f;
  }

  .single-name:deep .v-btn:not(.v-btn--round).v-size--default {
    max-width: 40px !important;
  }

  .list-fname hr {
    margin-top: 20px;
    border-color: #0000001f;
  }

  /* End roster names */
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
import folder from "./folder.vue";
import files from "./files.vue";

export default {
  name: "folder_list",
  components: { folder, files },
  mixins: [bus_common],
  data() {
    return {
      files_update: null,
      lst_fav_files: [],
      cur_folderName: "",
      show_folder: false,
      openDialog_fname_show: false,
      items_foldername: [],

      editedIndex_fname: -1,
      editeditem_fname: {
        name: "",
      },
      defaultitem_fname: {
        name: "",
      },
    };
  },
  computed: {},

  /* METHODS */
  methods: {
    get_favs() {
      console.log("get_favs");
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.folder_name = this.folder_name;

      formIn.apiname = "get_favs";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);

          self.lst_fav_files = data;
          self.lst_fav_files.forEach((item) => {
            item.s_date = self.format_date_us(item.s_date);
          });
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error get_favs", msg, "error", null, null);
        });
    },
    onPanelChange(panelIndex) {
      console.log("Opened panel index:", panelIndex);
      if (panelIndex === 0) {
        this.get_favs();
      }
    },
    backtofolders() {
      console.log("btf");
      this.cur_folderName = "";
      this.show_folder = false;
    },
    upload_file(form) {
      console.log(form.filename);
    },
    show_folder_now(folder_name) {
      this.cur_folderName = folder_name;
      this.show_folder = true;
    },
    get_all_folders() {
      this.show_loader(true);
      console.log("get all folders start");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_all_folders";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          console.log(data.length);
          self.items_foldername = data;
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error get_all_folders", msg, "error", null, null);
        });
    },
    init(self) {
      this.get_all_folders();

      this.show_loader(false);
    },
  },
  mounted() {
    this.show_loader(true);
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
